// https://developers.google.com/analytics/devguides/collection/analyticsjs/events
export function sendResubmitEvent() {
  const ga = window.ga;
  const isDev = process.env.NODE_ENV === "development";

  var eventAction = "Resubmitted request after error";
  var eventCategory = "Error Modal";

  if (isDev) {
    eventAction = `${eventAction} -- FROM DEV`;
  }

  if (!ga) {
    return null;
  }

  ga("send", "event", eventCategory, eventAction);
}



// WEBPACK FOOTER //
// ./src/util/analytics/sendEvents.js